import React, { useId } from 'react';

const IconRefresh = () => {
  const id = useId();
  const clipId = `clip-refresh-${id}`;
  const maskId = `mask-refresh-${id}`;

  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
      <g clipPath={`url(#${clipId})`}>
        <mask
          id={maskId}
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="12"
          height="12"
        >
          <path d="M6 6H0V12H12V0H0V2.5L6 6Z" fill="currentColor"/>
        </mask>
        <g mask={`url(#${maskId})`}>
          <circle cx="6" cy="6" r="5.5" stroke="currentColor"/>
        </g>
        <path d="M1 1V3H3" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="12" height="12" fill="currentColor"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconRefresh;
